import React from 'react'
import BoutonRetourHome from './BoutonRetourHome';

const Loading = ({values}) => {
    if (values.loading) {
        return (
          <div className="text-center mt-5">
            <div className="spinner-border " role="status">
              <span className="sr-only"></span>
            </div>
          </div>
        );
      }
      else if(values.errorOnFetch){
        return (
            <div>
                <div class="text-center mt-3 alert alert-danger">Le formulaire d'inscription n'est pas disponible actuellement, merci de réessayer plus tard</div>
                <BoutonRetourHome/>
            </div>
        )
    }
    else{
        return <div></div>
    }
}

export default Loading